function navigation(width) {

    var nav          = $('#_navigation'),
        button       = $('._js-nav-trigger'),
        clickAllowed = false,
        hoverAllowed = true,
        screenWidth  = $(window).width(),
        link         = $('._js-navigation-link'),
        linkBack     = $('._js-link-back'),
        level        = $('._js-navigation-level');

    button.on('click', function(){
        if ( !nav.hasClass('_active') ) {
            nav.addClass('_active');
        } else {
            nav.removeClass('_active');
        }
    });

    link.on('mouseenter mouseleave click', function(e){
        var id           = $(this).data('goto'),
            currentLevel = $('[data-level="'+id+'"]');

        if ( e.type === 'click' && clickAllowed) {
            e.preventDefault();
            if( !currentLevel.hasClass('_visible') ) {
                level.removeClass('_visible');
                currentLevel.addClass('_visible');
            }
            /*if ( $('.navigation__location').length ) {
                $('.navigation__location').hide();
            }
            if ( $('.navigation__options').length ) {
                $('.navigation__options').hide();
            }*/
        }
        else if (e.type === 'mouseenter' && hoverAllowed) {
            $(this).addClass('_active');
            currentLevel.addClass('_active');
        }
        else if (e.type === 'mouseleave' && hoverAllowed) {
            window.timer = setTimeout(function(){
                $('[data-goto="'+id+'"]').removeClass('_active');
                $('[data-level="'+id+'"]').removeClass('_active');
            }, 100);
        }

    });

    linkBack.on('click', function(){
        var id = $(this).data('goto');
        if( !$('[data-level="'+id+'"]').hasClass('_visible') ) {
            level.removeClass('_visible');
            $('[data-level="'+id+'"]').addClass('_visible');
        }

       /* if ( $('.navigation__location').length ) {
            $('.navigation__location').show();
        }
        if ( $('.navigation__options').length ) {
            $('.navigation__options').show();
        }*/
    });

    $('._js-navigation-level._sublevel').on('mouseenter mouseleave', function(e){
        if ( hoverAllowed ) {
            if ( typeof window.timer !== "undefined" && e.type === 'mouseenter' ) {
                clearTimeout(timer);
            }
            else if ( e.type === 'mouseleave' ) {
                window.timer = setTimeout(function(){
                    link.removeClass('_active');
                    level.removeClass('_active');
                }, 100);
            }
        }
    });

    $(window).on('load resize', function(){
        if ( screenWidth < width ) {
            clickAllowed = true;
            hoverAllowed = false;
        } else {
            clickAllowed = false;
            hoverAllowed = true;
        }
    });
    $(document).on('mouseup touchend', function(e){
        if (!nav.is(e.target) && nav.has(e.target).length === 0) {
            nav.removeClass('_active');
        }
    });

}